<template>
  <div class="tab">
    <div>
      <div v-if="listOrCon">
        <h3 class="title">成长型思维培养</h3>
        <List :listArr="listArr"></List>
        <h3 class="title">心理弹性干预</h3>
        <List :listArr="listArr1"></List>
      </div>
      <router-view v-if="!listOrCon" @returnPage="returnPage"></router-view>
    </div>
  </div>
</template>
<script>
import List from "../list/list";
export default {
  name: "growthThinking",
  data() {
    return {
      listArr: [
        {
          title: "什么是成长型思维",
          path: "growthThinking1",
          img: [require("../../assets/list4.png")],
          id: 1
        },
        {
          title: "成长思维对话术",
          path: "growthThinking2",
          img: [require("../../assets/list5.png")],
          id: 2
        },
        {
          title: "【不是鸡汤！】成长型思维模式可以带来学业提升",
          path: "growthThinking3",
          img: [require("../../assets/growthThinking/list3/640(3).png")],
          id: 3
        },
        {
          title: "三个不等式带你走出误区，远离“假”成长型思维",
          path: "growthThinking4",
          img: [require("../../assets//growthThinking/list4/ss.jpg")],
          id: 4
        },
        {
          title: "孩子在难题面前碰破头？家长还可以这样做！",
          path: "growthThinking5",
          img: [require("../../assets/growthThinking/list5/640(4).png")],
          id: 5
        },
        // {
        //   title: "孩子的梦想与父母的期待，该如何抉择？",
        //   path: "growthThinking6",
        //   img: [require("../../assets/growthThinking/list6/640.png")],
        //   id: 6
        // },
        {
          title: "活动照片分享",
          path: "growthThinking7",
          img: [require("../../assets/growthThinking/list7/1.png")],
          id: 7
        }
      ],
      listArr1: [
        {
          title: "提升心理弹性，促进积极发展",
          path: "growthThinking8",
          img: [require("../../assets/list1_3.png")],
          id: 1
        },
        {
          title: "促进处境不利儿童积极发展，我们在科研和实践的道路上",
          path: "growthThinking9",
          img: [require("../../assets/list2.png")],
          id: 2
        },
        {
          title: "心理弹性项目培训项目",
          path: "growthThinking10",
          img: [require("../../assets/list3.png")],
          id: 3
        }
      ],
      listOrCon: true
    };
  },
  methods: {
    returnPage() {
      this.listOrCon = true;
    }
  },
  watch: {
    $route(to, from) {
      if (to.matched.length == 3) {
        this.listOrCon = false;
      } else {
        this.listOrCon = true;
      }
    }
  },
  created() {
    if (this.$route.matched.length == 3) {
      this.listOrCon = false;
    }
  },
  components: {
    List
  }
};
</script>

<style scoped src="../../assets/style/grandchild.css">
/* @import '../assets/style/child.css'; */
</style>



// WEBPACK FOOTER //
// src/components/tabs/growthThinking.vue